import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  withStyles,
  Typography,
  Button,
  Link,
  IconButton,
  Tooltip,
  Dialog
} from '@material-ui/core'
import { CustomTextField } from '../../../components/CustomDisabledFields'
import { CustomAutocomplete } from '../../../components'
import { parseTelefone } from '../../../utils/Parse'
import DropzoneField from '../../../components/DropzoneField'
import CustomFileViewer from '../../../components/CustomFileViewer'
import ObservacaoField from '../../../components/ObservacaoField'
import { Alert } from '@material-ui/lab'
import { Info } from '@material-ui/icons'
import ReferenciaObservacaoDialogContent from './ReferenciaObservacaoDialogContent'
import DocumentValidator from '../../../components/DocumentValidator'
import CardFlex from '../Flex/CardFlex'
import CardGSVTech from '../GSVTech/CardGSVTech'

const StatusReferenciaPessoal = {
  TELEFONEINCORRETO: 'Telefone incorreto',
  NAOATENDE: 'Não atende',
  RECUSADARINFORMACOES: 'Se recusa a dar informações',
  NAOCONHECENAOSABEINFORMACOES: 'Não conhece e/ou não sabe dar informações',
  NAOPOSSUIGRAUPARENTESCO: 'Não possui grau de parentesco',
  OK: 'Ok'
}

const StatusReferenciaComercial = {
  TELEFONEINCORRETO: 'Telefone incorreto',
  NAOATENDE: 'Não atende',
  RECUSADARINFORMACOES: 'Se recusa a dar informações',
  NAOPOSSUICADASTRO: 'Não possui cadastro',
  NAOPOSSUIHISTORICO: 'Não possui histórico',
  HISTORICODESATUALIZADO: 'Histórico desatualizado',
  HISTORICOOK: 'Histórico com menos de 10 viagens dentro de 6 meses',
  HISTORICOOKMAISDE10: 'Histórico com 10 viagens ou mais dentro de 6 meses'
}

const Parentesco = {
  PAI: 'Pai',
  MAE: 'Mãe',
  ESPOSO: 'Esposo',
  ESPOSA: 'Esposa',
  FILHO: 'Filho',
  FILHA: 'Filha',
  IRMAO: 'Irmão',
  IRMA: 'Irmã'
}

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  title: {
    marginTop: theme.spacing(5)
  }
})

function ReferenciasForm({
  formChange,
  values,
  classes,
  showError,
  cannotUpdate
}) {
  const [refComercial, setRefComercial] = useState(null)

  const handleRemoveRefComercial = () => {
    setRefComercial(null)
  }

  const handleFileChange = (filePath, file) => {
    formChange(file, filePath)
  }

  const [rowsPessoal, setRowsPessoal] = useState(
    values.referenciasPessoais?.length || 3
  )
  const [rowsComercial, setRowsComercial] = useState(
    values.referenciasComerciais?.length || 3
  )

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        {values?.renovado && (
          <Grid item xs={12}>
            <Alert severity="info">
              Renovação de Solicitação⠀
              {values?.ultimaLiberadaId && (
                <Link
                  href={`/solicitacoesAnalista/${values?.ultimaLiberadaId}`}
                  target="_blank"
                  color="inherit"
                  underline="always"
                  style={{ cursor: 'pointer' }}
                >
                  Consultar Última
                </Link>
              )}
            </Alert>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography id="referenciaspessoais" variant="h6" gutterBottom>
            Referências Pessoais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {[...Array(rowsPessoal).keys()].map(i => (
            <Grid key={i} container spacing={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      label="Nome"
                      name={`referenciasPessoais[${i}].nome`}
                      showError={showError}
                      disabled={cannotUpdate}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      component={CustomAutocomplete}
                      hideEmpty
                      options={Object.values(Parentesco).map(parentesco => ({
                        label: parentesco,
                        value: parentesco
                      }))}
                      label="Parentesco"
                      name={`referenciasPessoais[${i}].parentesco`}
                      showError={showError}
                      disabled={cannotUpdate}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      label="Telefone"
                      name={`referenciasPessoais[${i}].telefone`}
                      showError={showError}
                      format={parseTelefone}
                      disabled={cannotUpdate}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <Field
                      disabled={cannotUpdate}
                      fullWidth
                      parse={val => (val == null ? '' : val)}
                      component={CustomAutocomplete}
                      options={Object.values(StatusReferenciaPessoal).map(
                        value => ({
                          value: value,
                          label: value
                        })
                      )}
                      label="Status"
                      name={`referenciasPessoais[${i}].status`}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Field
                      parse={val => (val == null ? '' : val)}
                      disabled={cannotUpdate}
                      fullWidth
                      component={CustomTextField}
                      label="Observação"
                      name={`referenciasPessoais[${i}].observacao`}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12}>
          <Grid container alignItems="flex-end" justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                className={classes.marginTop}
                disabled={rowsPessoal <= 3 || cannotUpdate}
                onClick={() => {
                  if (rowsPessoal > 3) setRowsPessoal(rowsPessoal - 1)
                }}
              >
                -
              </Button>
              <Button
                variant="outlined"
                className={classes.marginTop}
                onClick={() => {
                  setRowsPessoal(rowsPessoal + 1)
                }}
                disabled={cannotUpdate}
              >
                +
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <DocumentValidator
            legend="Referências dispensada pelo histórico?"
            name="referenciasDispensada"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography
            id="referenciascomerciais"
            className={classes.title}
            variant="h6"
          >
            Referências Comerciais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {[...Array(rowsComercial).keys()].map(i => {
            const isRefConfiavel = !!values?.referenciasComerciais?.[i]
              ?.transportadoraConfiavelId

            return (
              <Grid key={i} container spacing={4}>
                <Grid item xs={12} md={6}>
                  <Grid container spacing={4}>
                    <Grid item xs={12}>
                      <Grid container alignItems="center">
                        <Grid item xs>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            label="Nome"
                            name={`referenciasComerciais[${i}].nome`}
                            showError={showError}
                            disabled={cannotUpdate}
                          />
                        </Grid>
                        {isRefConfiavel && (
                          <Grid item xs="auto">
                            <Tooltip title="Observações">
                              <IconButton
                                onClick={() =>
                                  setRefComercial(
                                    values?.referenciasComerciais?.[i]
                                  )
                                }
                                color="primary"
                              >
                                <Info />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        label="E-mail"
                        name={`referenciasComerciais[${i}].email`}
                        showError={showError}
                        disabled={cannotUpdate}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        label="Telefone"
                        name={`referenciasComerciais[${i}].telefone`}
                        showError={showError}
                        format={parseTelefone}
                        disabled={cannotUpdate}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container spacing={4}>
                    <Grid item xs={12}>
                      <Field
                        disabled={cannotUpdate}
                        fullWidth
                        component={CustomAutocomplete}
                        options={Object.keys(StatusReferenciaComercial).map(
                          key => ({
                            value: key,
                            label: StatusReferenciaComercial[key]
                          })
                        )}
                        label="Status"
                        name={`referenciasComerciais[${i}].status`}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        parse={val => (val == null ? '' : val)}
                        disabled={cannotUpdate}
                        fullWidth
                        component={CustomTextField}
                        label="Observação"
                        name={`referenciasComerciais[${i}].observacao`}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )
          })}
        </Grid>
        <Grid item xs={12}>
          <Grid container alignItems="flex-end" justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                className={classes.marginTop}
                disabled={rowsComercial <= 3 || cannotUpdate}
                onClick={() => {
                  if (rowsComercial > 3) setRowsComercial(rowsComercial - 1)
                }}
              >
                -
              </Button>
              <Button
                variant="outlined"
                className={classes.marginTop}
                onClick={() => {
                  setRowsComercial(rowsComercial + 1)
                }}
                disabled={cannotUpdate}
              >
                +
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CardGSVTech solicitacaoId={values.id} />
        </Grid>
        <Grid item xs={12}>
          <CardFlex solicitacaoId={values.id} />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.title} variant="h6">
            Comprovante de Viagens
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Field
            solicitacaoId={values.id}
            accept=".jpg,.jpeg,.png,.pdf"
            component={DropzoneField}
            label="Comprovante de Viagens"
            name="comprovanteViagens"
            onFileChange={filePath =>
              handleFileChange(filePath, 'comprovanteViagens')
            }
            showError={showError}
            disabled={cannotUpdate}
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <CustomFileViewer
            newTab
            label="Comprovante de Viagens"
            filePath={values.comprovanteViagens}
            fileType="pdf"
          />
        </Grid>
        <ObservacaoField
          value={values.observacaoReferencias}
          title="Observações Referências"
          placeholder="Escreva aqui observações sobre as referências"
          name="novaObservacaoReferencias"
          disabled={cannotUpdate}
        />
        <Dialog open={!!refComercial} onClose={handleRemoveRefComercial}>
          <ReferenciaObservacaoDialogContent
            refComercial={refComercial}
            handleClose={handleRemoveRefComercial}
          />
        </Dialog>
      </Grid>
    </div>
  )
}

export default withStyles(styles)(ReferenciasForm)
